import { TextField } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useUpdateContragentMutation } from "../../../store/contragentApi";

export default function Contragent({ item, id, onClose }) {
  const [updateContragent] = useUpdateContragentMutation();
  const [name, setName] = React.useState(item.attributes.name);
  const [surname, setSurname] = React.useState(item.attributes.surname);
  const [lastname, setLastname] = React.useState(item.attributes.lastname);
  const [birthday, setBirthday] = React.useState(item.attributes.birthday);
  const [passport, setPassport] = React.useState(item.attributes.passport);
  const [address, setAddress] = React.useState(item.attributes.address);
  const [inn, setInn] = React.useState(item.attributes.inn);
  const [phone, setPhone] = React.useState(item.attributes.phone);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?")
    const updated = {
      name,
      surname,
      lastname,
      birthday,
      passport,
      address,
      inn,
      phone,
    };
    updateContragent({updated, id })
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfContragent>Карточка контрагента</TitleOfContragent>
      <StyledNameBlock>
        <StyledNameTextField
          id="outlined-basic"
          label="Фамилия"
          variant="outlined"
          value={surname}
          onChange={(event) => inputChangeHandler(event, setSurname)}
        />
        <StyledNameTextField
          id="outlined-basic"
          label="Имя"
          variant="outlined"
          value={name}
          onChange={(event) => inputChangeHandler(event, setName)}
        />
        <StyledNameTextField
          id="outlined-basic"
          label="Отчество"
          variant="outlined"
          value={lastname}
          onChange={(event) => inputChangeHandler(event, setLastname)}
        />
      </StyledNameBlock>
      <BlockStyled
        margin="10px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStyled
          id="date"
          type="date"
          label="Дата рождения"
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          value={birthday}
          onChange={(event) => inputChangeHandler(event, setBirthday)}
          width="25%"
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Паспортные данные"
          variant="outlined"
          value={passport}
          onChange={(event) => inputChangeHandler(event, setPassport)}
          width="70%"
        />
      </BlockStyled>
      <StyledFirstBlock>
        <StyledAddressTextField
          id="outlined-basic"
          label="Адрес"
          variant="outlined"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
        />
        <StyledSmallTextFields
          id="outlined-basic"
          label="ИНН"
          variant="outlined"
          value={inn}
          onChange={(event) => inputChangeHandler(event, setInn)}
        />
        <StyledSmallTextFields
          id="outlined-basic"
          label="Телефон"
          variant="outlined"
          value={phone}
          onChange={(event) => inputChangeHandler(event, setPhone)}
        />
      </StyledFirstBlock>
      <StyledSecondBlock>
        
        
      </StyledSecondBlock>
      <StyledThirddBlock>
        <BasicButtons onClick={onClose}>Отменить</BasicButtons>
        <BasicButtons type="submit">Сохранить</BasicButtons>
      </StyledThirddBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStyled = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const StyledNameBlock = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

const StyledNameTextField = styled(TextField)`
  width: 33%;
`;

const StyledFirstBlock = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

const StyledAddressTextField = styled(TextField)`
  width: 55%;
`;

const StyledSecondBlock = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
`;
const StyledThirddBlock = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const TitleOfContragent = styled.h3`
  text-align: center;
`;

const StyledSmallTextFields = styled(TextField)`
  width: 20%;
  margin: ${(props) => props.mrg};
`;
const StyledForm = styled.form``;
